Pixlee.module('PhotowallApp.Show', function(Show, App, Backbone, Marionette, $) {

    Show.Layout = App.Views.Layout.extend({
        template: require('./templates/layout.jst.ejs'),
        regions: {
            widget_header_region: '#widget_header_region',
            interactive_region: '#interactive_region',
            frame: '.photowall_frame'
        },
        collectionEvents: {
            'sync': function() {
                if (!this.collection.next) {
                    this.$el.find(".load_more").hide();
                }
            }
        },
        events: {
            'click .load_more': function() {
                this.$el.find('.load_more').addClass('loading');
                var _this = this;
                this.collection.nextPage({
                    success: function() {
                        _this.$el.find('.load_more').removeClass('loading');
                        App.commands.execute('load:more', _this.collection.pluck('album_photo_id'));

                        if (!_this.collection.next) {
                            _this.$el.find(".load_more").hide();
                        }
                    }
                });

            }
        },
        initialize: function() {
            this.displayOptions = App.displayOptions;
        },
        onRender: function() {
            // Check if infinite load more display option is enabled
            if (!_.isFalsy(App.displayOptions.get("infiniteLoadMore"))) {
                this.$el.find(".load_more").remove();
                this.waitForLoadMoreRequest();
            }
        },
        infiniteLoadMore: function() {
            if (this.collection.next) {
                this.$el.find("#photowall_control").append("<div class=\"load_more loading\"></div");
                this.collection.nextPage({
                    success: function() {
                        if (this.finishedFirstLoad) {
                            App.commands.execute('load:more', this.collection.pluck('album_photo_id'));
                        }
                        this.finishedFirstLoad = true;
                        this.$el.find(".load_more").remove();
                        this.is_loading = false;
                    }.bind(this)
                });
            }
        },
        waitForLoadMoreRequest: function() {
            var _this = this;
            var receiveMessage = _.throttle(function(event) {
                try {
                    var eventData = JSON.parse(event.data);

                    if (eventData.name === 'pixlee:infinite:load:more' && !_this.is_loading) {
                        _this.infiniteLoadMore();
                        _this.is_loading = true;
                    }
                } catch (e) {
                    return;
                }

            }, 1000);

            window.addEventListener("message", receiveMessage, false);
        }
    });

    Show.Layout.include(['LayoutHelpers', 'AccessibilityHelpers']);

    Show.PhotoView = App.Views.ItemView.extend({
        template: require('../../common/templates/v2/_photo_item.jst.ejs'),
        className: 'photo_block',
        tagName: 'li',
        behaviors: {
            Reviews: {},
            Share: {},
            Vote: {},
            Lightbox: {},
            UpdateThumbnailCss: {}
        },
        initialize: function() {
            if (this.model.get('is_starred')) {
                this.$el.addClass('starred');
            }
        },
        templateHelpers: {
            decodeUtf8: function(string) {
                return App.request('decode:utf8', string);
            }
        }
    });
    Show.PhotoView.include(['PhotoViewHelpers', 'ReviewHelpers']);

    // Photowall View
    Show.PhotowallCollection = App.Views.CompositeView.extend({
        template: require('./templates/_collection_view.jst.ejs'),
        childView: Show.PhotoView,
        childViewContainer: '#item_container',
        behaviors: function() {
            var behaviorHash = {
                CollectionVote: {}
            };

            // for backwards compatibility with widgets that are already out in the wild
            if (!_.isFalsy(this.options.displayOptions.headerOptions)) {
                behaviorHash.AppendUploaderTiles = {};
                if (this.options.displayOptions.headerOptions.layout === 'tile') {
                    behaviorHash.Upload = {};
                }
            }
            // if there's no upload tiles or if hideIfLessThanIsSet is set, then we need to have the ability to hide empty albums
            var noUploadButton = _.isFalsy(this.options.displayOptions.headerOptions.end_tile_upload_button_background_showHide);
            var setHideIfLessThan = !_.isFalsy(App.displayOptions.get('hideIfLessThan')) || !_.isFalsy(gon.current_account.extra_fields.hideIfLessThan);
            if (noUploadButton || setHideIfLessThan) {
                behaviorHash.HideEmptyAlbumWidget = {};
            }

            return behaviorHash;
        },
        initialize: function(options) {
            this.collection.reviewSelectionOptions = {
                currentModelIndex: 0
            };
        },
        onShow: function() {
            $('#widget').attr('alt', App.altText);
        },
        onRender: function() {
            var _this = this;
        },
    });
    Show.PhotowallCollection.include(['headerHelpers', 'designEditorCollectionHelpers', 'socialShareHelpers']);

    Show.HeaderView = App.Views.ItemView.extend({
        template: require('../../common/templates/v2/_header.jst.ejs'),
        id: 'widget_header',
        behaviors: {
            Upload: {},
            ShowPdpCaption: {}
        }
    });

    Show.HeaderView.include(["StandaloneHeaderHelpers"]);

});
